<template>
  <div>
    <el-button class="goBack" @click="goBack">返回</el-button>
    <div class="setSome">
        <div class="title_1">
            <div class="iconShow"></div>
            <div class="titleText">标段详情</div>
        </div>
        <div class="sectionSetItem">
            <div class="itemText">标段名称</div>
            <div class="inputCon">
                <el-input placeholder="请输入标段名称" v-model="addObj.sectionName"></el-input>
            </div>
        </div>
        <div class="sectionSetItem">
            <div class="itemText">所属层</div>
            <div class="inputCon">
                <el-input placeholder="请输入所属层" v-model="addObj.roadName" disabled></el-input>
            </div>
        </div>
        <div class="sectionSetItem">
            <div class="itemText">所属路幅</div>
            <div class="inputCon">
                <el-select v-model="addObj.roadway" placeholder="请选择所属路幅" disabled>
                    <el-option
                    v-for="item in roadwayList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="sectionSetItem">
            <div class="itemText">标段范围：</div>
            <span 
              @click="selectAllPointer"
              style="display:inline-block;height:30px;lineHeight:24px;border:1px solid #E96B5A;padding:3px 6px;borderRadius:5px;marginLeft:163px;cursor:pointer;fontSize:14px;background:#fde3e1;color:#E96B5A">
              选择全部
            </span>
        </div>
        <div class="sectionSetItem">
            <div class="itemText">起始桩号</div>
            <div class="inputCon">
                K  
                <el-input @change="changeSetGray" type="number" class="mileage mileage_1" placeholder="" v-model="startMileage_1" onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"></el-input>
                + 
                <el-input @change="changeSetGray" type="number" class="mileage mileage_2" placeholder="" v-model="startMileage_2" oninput="if(isNaN(value)) { value = parseFloat(value) } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"></el-input>
            </div>
        </div>
        <div class="sectionSetItem">
            <div class="itemText">结束桩号</div>
            <div class="inputCon">
                K  
                <el-input @change="changeSetGray" type="number" class="mileage mileage_1" placeholder="" v-model="endMileage_1" onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"></el-input>
                + 
                <el-input @change="changeSetGray" type="number" class="mileage mileage_2" placeholder="" v-model="endMileage_2" oninput="if(isNaN(value)) { value = parseFloat(value) } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"></el-input>
            </div>
        </div>
        <div class="sectionSetItem" style="margin-bottom:42px">
            <div class="itemText">当前划定里程</div>
            <div class="inputCon">
                <el-input style="color: #282828" placeholder="" v-model="mileageValue" disabled></el-input>
            </div>
        </div>

        <div class="title_1">
            <div class="iconShow"></div>
            <div class="titleText">顶点坐标</div>
            <div class="changePointer">调整顶点坐标</div>
        </div>

        <div class="pointerList">
            <div class="listContain">
                <div class="tablelistBody">
                <el-table
                :data="dataList"
                style="width: 100%"
                size="medium"
                v-loading="listLoading"
                >
                    <el-table-column prop="name" label="顶点" width="">
                        <template slot-scope="scope">
                        <span class="pointerName">{{scope.row.name}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="x" label="X轴" width=""></el-table-column>
                    <el-table-column prop="y" label="Y轴" width=""></el-table-column>
                </el-table>
            </div>
            </div>
        </div>

        <div class="sectionBtn addSection" @click="addSection">创建标段</div>
        <div class="sectionBtn saveDiv" :class="setGray == 1?'setGray':''" @click="saveFun">保存</div>
    </div>
    <div class="canvasConRoad">
        <div class="canvas-container4">
            <canvas id="myCanvas" width="1533" height="953"></canvas>
            <canvas id="dhCanvasRoad" width="1533" height="953"></canvas>
        </div>
    </div>
  </div>
</template>

<script>
import {fabric} from 'fabric'
  import { setCalculateVertex,getRoadCordInfo,getRoadInfoDetails,addRoadSection,getRoadSection,editRoadSection } from '../../utils/api'
  import { 
    //   setRoad,
//   canvasInit,
  setGrid,
//   setPointers,
//   setPointArea,
setPointersb,
  setPointAreab
   } from '../../utils/canvasSet'
  import { MaxFn,compare,unCompare,sliceArr,changeRoadPointer,haveRoadChangePoints } from '../../utils/commons'
  import mixinList from "../../utils/mixinList"
  import canvasMix from "../../utils/canvasMix"
import { Message } from 'element-ui'
//   import { clearNoNum } from '../../utils/commons'
  export default {
    name      : 'app',
    mixins: [mixinList,canvasMix],
    data() {
      return {
        addObj:{
            roadway:'',
            roadName:'',
            sectionName:'',
        },
        startMileage_1: 0,
        startMileage_2: 0,
        startMileage:0,
        endMileage_1: 0,
        endMileage_2: 0,
        endMileage: 0,
        dataList: [],
        setGray: 1,
        mileageValue:'',
        roadwayList:[
            {
                label: '左幅',
                value: '左幅',
            },
            {
                label: '右幅',
                value: '右幅',
            },
        ],
        arrowList: [
            {
                name: '工程中心',
                path: '/transfer'
            },
            {
                name: '道路管理',
                path: '/transfer/roadList'
            },
            {
                name: '标段划分',
                path: '/transfer/roadSection'
            },
        ],
        roadId:'',
        roadType: '',
        roadPointers: [],
        pileNumPointers: [],
        canvasBG: '#ffffff',
        inType: '',
        sectionId: '',
        canvas: '',
        cengid:'',
      }
    },
    computed:{

    },
    created(){

    },
    mounted(){
        this.$store.commit('setArrowList', this.arrowList)
        this.roadId = this.$route.query.id
        this.roadType = this.$route.query.roadType
        this.cengid = this.$route.query.cengid
        this.addObj.roadType = this.$route.query.roadType
        this.inType = this.$route.query.type
        
        getRoadInfoDetails({id: this.roadId}).then(res => {
            this.loading=false
            let roadTableVoList=res.data.content.info.list
            roadTableVoList.map(item=>{
                if(this.cengid==item.id){
                    this.roadPointers = item.stdRoadMap
                    this.addObj.roadName=item.roadName
                    this.addObj.roadway=item.roadway
                    this.startMileage=item.startMileage
                    this.endMileage=item.endMileage
                    console.log(this.addObj,'this.addObj')
                    // sectionDataList=item.roadSectionVoList
                    getRoadCordInfo({roadId: item.id}).then(res => {
                        this.roadPointers = res.data.content.dataMap
                        let changeObj = changeRoadPointer(1533,953,this.roadPointers,false)
                        let getChangeObj = changeObj[0]
                        let scaleCode = changeObj[1]
                        this.$store.commit('setScaleCode', scaleCode)
                        this.canvas = new fabric.Canvas("dhCanvasRoad",{
                            perPixelTargetFind: true
                        });
                        this.canvas.selectable = false
                        this.initCanvas(this.canvas,'',getChangeObj,2)


                        // setRoad(getChangeObj)
                        let getList = res.data.content.dataMap.middleLine.sort(compare("pileNum"))
                        let minPileNum = []
                        for(let i=0;i<getList.length;i++){
                            minPileNum.push(getList[i].pileNum)
                        }
                        this.pileNumPointers = minPileNum

                        if(this.inType == 'edit'){
                            this.sectionId = this.$route.query.sectionId
                            let params = {sectionId:this.sectionId}
                            getRoadSection(params).then(res => {
                                //console.log(res)
                                let data = res.data.content.info
                                this.addObj = data
                                this.addObj.roadName = data.layer
                                this.dataList = data.vertexList
                                this.mileageValue = (data.mileage).toFixed(2) + 'm'
                                this.startMileage_1 = parseInt(data.startMileage/1000)
                                this.startMileage_2 = data.startMileage - this.startMileage_1*1000
                                //console.log(this.startMileage_2)
                                this.endMileage_1 = parseInt(data.endMileage/1000)
                                this.endMileage_2 = data.endMileage - this.endMileage_1*1000

                                let params = {
                                    roadId : this.roadId,
                                    startMileage: this.startMileage_1*1000+this.startMileage_2*1,
                                    endMileage: this.endMileage_1*1000+this.endMileage_2*1,
                                }
                                let verList = data.vertexList
                                this.drawFun(verList,params)
                            })
                        }
                    })
                }
            })
            console.log(this.addObj,'addObj')
            
            
        })
        setGrid(this.canvasBG)
        

        
    },
    methods: {
        //选择全部
        selectAllPointer(){
            this.startMileage_1 = parseInt(this.startMileage/1000)
            this.startMileage_2 = this.startMileage - this.startMileage_1*1000
            this.endMileage_1 = parseInt(this.endMileage/1000)
            this.endMileage_2 = this.endMileage - this.endMileage_1*1000
        },
        goBack: function(){
                this.$router.go(-1)
            },
        changeSetGray: function(){
            this.setGray = 1
        },
        addSection: function(){
            let params = {
                roadId : this.cengid,
                startMileage: this.startMileage_1*1000+this.startMileage_2*1,
                endMileage: this.endMileage_1*1000+this.endMileage_2*1,
            }
            //console.log(params)
            this.addObj.roadId = params.roadId
            this.addObj.startMileage = params.startMileage
            this.addObj.endMileage = params.endMileage
            
            setCalculateVertex(params).then(res => {
                let data = res.data.content.dataList
                this.drawFun(data,params)
            })
        },
        drawFun: function(data,params){
            this.dataList = data
            this.addObj.vertexList = data
            this.setGray = 2
            this.mileageValue = (Math.abs(params.endMileage - params.startMileage)).toFixed(2) + 'm'
            this.addObj.mileage = Math.abs(params.endMileage - params.startMileage)
            let startValue = MaxFn(params.startMileage,this.pileNumPointers)
            let endValue = MaxFn(params.endMileage,this.pileNumPointers)
            // startValue = startValue >15?startValue-15:0
            // endValue = endValue < this.pileNumPointers.length-15?endValue+15:this.pileNumPointers.length
            //截取数组
            let leftArr = sliceArr(startValue,endValue,this.roadPointers.leftLine.sort(compare("pileNum")))
            // let midArr = sliceArr(startValue,endValue,this.roadPointers.middleLine.sort(compare("pileNum")))
            let rightArr = sliceArr(startValue,endValue,this.roadPointers.rightLine.sort(compare("pileNum")))
            // let setObj = {
            //     leftLine: leftArr,
            //     middleLine: midArr,
            //     rightLine: rightArr,
            // }
            //console.log(setObj)
            let changeObj = changeRoadPointer(1533,953,this.roadPointers,false)
            // let getChangeObj = changeObj[0]
            let scaleCode = changeObj[1]
            //console.log(scaleCode)
            this.$store.commit('setScaleCode', scaleCode)
            let getList = data
            
            //获取顶点转换坐标及画点
            let setChangeList = []
            for(let i=0;i<getList.length;i++){
                setChangeList.push({
                    xcord: getList[i].x,
                    ycord: getList[i].y,
                })
            }
            let setChangeEnd = haveRoadChangePoints(setChangeList)
            //获取区域坐标及连线
            let lineList = leftArr.concat(rightArr.sort(unCompare("pileNum")))
            let areaArr = []
            for(let i=0;i<lineList.length;i++){
                areaArr.push({
                    xcord: lineList[i].xcord,
                    ycord: lineList[i].ycord,
                })
            }
            let areaArrEnd = haveRoadChangePoints(areaArr)
            // let scaleData = this.$store.state.scaleCode.toFixed(2)
            // setGrid("#ffffff")
            // setRoad(getChangeObj)
            // canvasInit(getChangeObj,areaArrEnd,setChangeEnd,"#ffffff")
            setPointAreab(this.canvas,areaArrEnd)
            setPointersb(this.canvas,setChangeEnd)
        },
        saveFun: function(){
            let params = this.addObj
            if(this.addObj.sectionName==''){
                Message.warning('请填写作业块名称！')
                return
            }
            if(this.inType == 'edit'){
                editRoadSection(params).then((res) => {
                    //console.log(res)
                    if(res.data.code==200){
                        this.$router.push({name:'RoadInfo'})
                    }
                })
            }else{
                addRoadSection(params).then((res) => {
                    //console.log(res)
                    if(res.data.code==200){
                        this.$router.push({name:'RoadInfo'})
                    }
                })
            }
            
        }
    },
    components:{
            
    }
  }
</script>
<style lang="scss">
.canvas-container4{
  .canvas-container{
    position: fixed !important;
    top: 113px !important;
    left: 370px !important;
  }
} 
.sectionSetItem{
    .inputCon{
        height: 35px;
        width: 208px;
        margin-right: 16px;
        float: right;
        line-height: 35px;
        font-size: 14px;
        color: #282828;
        .el-input{
            height: 35px;
            width: 208px;
            input{
                height: 35px !important;
                width: 208px !important;
                border-radius: 0;
            }
        }
        .mileage{
            height: 35px;
            width: 75px;
            
            input{
                height: 35px !important;
                width: 75px !important;
            }
        }
        .mileage_1{
            margin: 0 9px;
        }
        .mileage_2{
            margin-left: 10px;;
        }
    }
}
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button{
    -webkit-appearance: none !important;
    margin: 0;
    }
    input[type="number"]{-moz-appearance:textfield;}
</style>
<style lang="scss" scoped="">
    .goBack{
        position: fixed;
        right: 16px;
        top: 68px;
        height: 35px !important;
        padding-left: 16px !important;
        padding-right: 16px !important;
         z-index: 999;
    }
    .pointerName{
        display: inline-block;
        color: #ffffff;
        font-size: 14px;
        padding: 7px;
        background:#E96B5A;
        line-height: 11px;
    }
    .setSome{
        width: 340px;
        height: 953px;
        background-color: #ffffff;
        margin-left: 15px;
        padding-top: 20px;
        position: relative;
        float: left;
        .title_1{
            height: 17px;
            width: 100%;
            position: relative;
            margin-bottom: 27px;
            .changePointer{
                width:90px;
                height:30px;
                background:rgba(254,235,232,1);
                border:1px solid rgba(233, 107, 90, 1);
                line-height: 28px;
                text-align: center;
                position: absolute;
                right: 16px;
                top: -6px;
                font-size: 12px;
                color: #E96B5A;
            }
            .iconShow{
                width:4px;
                height:16px;
                background:rgba(233,107,90,1);
                position: absolute;
                top: 0;
                left: 17px;
            }
            .titleText{
                height: 17px;
                line-height: 17px;
                font-size: 16px;
                font-weight: bold;
                color: #222222;
                position: absolute;
                top: 0;
                left: 30px;
            }
        }
        .sectionSetItem{
            width: 100%;
            height: 35px;
            margin-top: 11px;
            // background-color: aqua;
            .itemText{
                height: 35px;
                line-height: 35px;
                width: auto;
                padding-left: 18px;
                color: #222222;
                font-size: 14px;
                float: left;
            }
            
        }
        .pointerList{
            width: 309px;
            height: auto;
            margin: 0 auto;
            margin-top: 36px;
        }
        .sectionBtn{
            height: 45px;
            width: 150px;
            position: absolute;
            background:rgba(233,107,90,1);
            color: #ffffff;
            line-height: 45px;
            text-align: center;
            font-weight:bold;
            font-size: 15px;
            cursor: pointer;
        }
        .setGray{
            background:gray !important;
            pointer-events: none;
        }
        .addSection{
            left: 15px;
            bottom: 100px;
        }
        .saveDiv{
            right: 15px;
            bottom: 100px;
        }
    }

    .canvasConRoad{
        width: 1533px;
        height: 953px;
        background-color: #ffffff;
        margin-left: 15px;
        float: left;
        position: relative;
        #myCanvas{
                position: absolute;
                top: 0;
                left: 0;
            }
            #dhCanvasRoad{
                position: absolute;
                top: 0;
                left: 0;
            }
    }
</style>